/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PageMeta_root$ref: FragmentReference;
declare export opaque type PageMeta_root$fragmentType: PageMeta_root$ref;
export type PageMeta_root = {|
  +cms: {|
    +pageWithData: ?{|
      +page: {|
        +title: ?string,
        +description: ?string,
      |}
    |}
  |},
  +$refType: PageMeta_root$ref,
|};
export type PageMeta_root$data = PageMeta_root;
export type PageMeta_root$key = {
  +$data?: PageMeta_root$data,
  +$fragmentRefs: PageMeta_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "lang"
    },
    {
      "kind": "RootArgument",
      "name": "uid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageMeta_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CMS",
      "kind": "LinkedField",
      "name": "cms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "lang",
              "variableName": "lang"
            },
            {
              "kind": "Variable",
              "name": "uid",
              "variableName": "uid"
            }
          ],
          "concreteType": "CMSPageWithData",
          "kind": "LinkedField",
          "name": "pageWithData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CMSPage",
              "kind": "LinkedField",
              "name": "page",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '737a09ea2b217bc00d095c4513bed2c4';

export default node;
